import { ResolveFn } from '@angular/router';
import {InvioMail} from "@models/InvioMail.model";
import {inject} from "@angular/core";
import {APIService} from "@shared/api.service";

export const invioMailResolver: ResolveFn<InvioMail> = (route, state) => {
  const apiService = inject(APIService);
  return apiService.get('customerinfodigests/stats');
};
